import styled from 'styled-components';
import { propStyles } from '../../../utils/propStyles';

const StyledComponent = styled<any, any>('ol')`
    ${propStyles};
    list-style: none;
    -ms-overflow-style: -ms-autohiding-scrollbar;
`;

StyledComponent.defaultProps = {
    maxHeight: '300px',
    overflowX: 'hidden',
    overflowY: 'auto',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Dropdown/StyledComponents/DropdownList.tsx